<template>
  <div class="martket py-6">
    <div class="m-auto m-0">
      <h1 class="text-center text-2xl flex items-center justify-center -mx-3">
        <img src="@/assets/img/addons/market.svg" class="h-8 px-3" />
        <span class="px-3">{{
          showMine ? "My Accessories" : "vNFT Bazaar"
        }}</span>
        <img src="@/assets/img/addons/market.svg" class="h-8 px-3" />
      </h1>
    </div>

    <div>
      <div class="">
        <div class="text-xl p-2 flex items-center justify-end">
          <!-- <div class="">{{ showMine ? "My Accessories" : "Market" }}</div> -->
          <div class="">
            <button class="btn" @click="toggleView">
              <span v-if="!showMine"> My accessories </span>
              <span v-else> Market </span>
            </button>
          </div>
        </div>
        <div v-if="showMarket">
          <Market />
        </div>
        <div v-if="showMine">
          <MyAccessories />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Market from "../components/Market.vue";
import MyAccessories from "../components/MyAccessories.vue";
export default {
  components: { Market, MyAccessories },
  data: function () {
    return {
      showMarket: true,
      showMine: false,
    };
  },
  methods: {
    toggleView: function (tab) {
      this.showMarket = !this.showMarket;
      this.showMine = !this.showMine;
    },
  },
  mounted: function () {},
};
</script>
